module.exports = __webpack_public_path__ + "static/media/carta_17.9e042c3d.jpg";